import { render, staticRenderFns } from "./BdRTC.vue?vue&type=template&id=2d7a15d6&scoped=true&"
import script from "./BdRTC.vue?vue&type=script&lang=js&"
export * from "./BdRTC.vue?vue&type=script&lang=js&"
import style0 from "./BdRTC.vue?vue&type=style&index=0&id=2d7a15d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a15d6",
  null
  
)

export default component.exports